// extracted by mini-css-extract-plugin
export default {"declineFormModal":"styles_declineFormModal__kN-9L","icon":"styles_icon__9bzGq"};